<template>
  <el-container>
    <el-main style="padding: 0">
      <div>
        <view-table
            ref="viewTable"
            :filter="filter"
            :limits="limits"
            :columns-property="columnsProperty"
            module="basic"
            url="inspectionItems"
            @addOrEdit="addEditHandle"
            @select="selectHandle"
            @delete="deleteHandle"
            @reset="resetHandle">
          <template slot="adSearch">
            <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
              <el-form-item label="编号：">
                <el-input v-model.trim="filter.no" placeholder="请输入编号" clearable/>
              </el-form-item>
              <el-form-item label="名称：">
                <el-input v-model.trim="filter.name" placeholder="请输入名称" clearable/>
              </el-form-item>
            </el-form>
          </template>
        </view-table>
        <!-- 编辑 -->
        <inspection-item-edit ref="inspectionEdit" @save-success="loadData"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import InspectionItemEdit from "./InspectionItemEdit";

  export default {
    name: "InspectionItemList",
    components: {
      ViewTable,
      InspectionItemEdit,
    },
    data() {
      return {
        limits:{
          addAuth: this.$auth(434),
          editAuth: this.$auth(435),
          delAuth: this.$auth(436),
        },
        importLoading: false,
        mainBoxHeight: 0,
        data: [],
        filterText: "",
        filter: {
          no: "",
          name: "",
        },
        columnsProperty:[
          {
            key:"no",
            align:"center",
          },
          {
            key:"name",
            align:"center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
      };
    },

    methods: {
      addEditHandle(row) {
        this.$refs.inspectionEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除(单删、多删)
      deleteHandle(row) {
        console.log(row);
        let ids = [];
        ids.push(row.employeeID);
        this.$http.delete("basic", "inspectionItems", row.pkId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // checkBox
      selectHandle(selection) {
        this.selection = selection;
        console.log(this.selection);
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
<style scoped>
</style>

<style>
</style>
